// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__PA4jp {
  max-width: 800px;
  margin: 1rem;
  padding: 1rem;
  background: #ffffff;
  border-radius: 10px;
  height: 70vh;
  overflow-y: scroll;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.styles_title__PIxt3 {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}

.styles_subtitle__Xzbtg {
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  color: #555;
}

.styles_divider__\\+SDsj {
  border: none;
  height: 1px;
  background: #ddd;
  margin: 20px 0;
}

.styles_stepTitle__O4wTd {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
}

.styles_stepDescription__v7yf1 {
  font-size: 16px;
  margin-bottom: 10px;
}

.styles_subStep__O6yfH {
  font-size: 18px;
  font-weight: bold;
  margin-top: 15px;
  color: #333;
}

.styles_cnpj__2N4\\+u {
  font-size: 18px;
  font-weight: bold;
  color: #d9534f;
}

.styles_category__KyIWk {
  font-size: 16px;
  font-weight: bold;
  color: #0056b3;
  margin-top: 10px;
}

.styles_list__BdEnI {
  padding-left: 20px;
  list-style-type: disc;
}

.styles_list__BdEnI li {
  font-size: 14px;
  margin-bottom: 5px;
}

a {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}

.styles_btn_close__RJw1U {
  border: 2px solid #18316e !important;
  color: #18316e !important;
  transition: 500ms all !important;
  margin-top: 1rem;
  &:hover {
    background: #18316e !important;
    border: 2px solid #18316e !important;
    color: #fff !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SelecionarTiposNegocio/ModalArquivos/ManualProcuracao/styles.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  max-width: 800px;\n  margin: 1rem;\n  padding: 1rem;\n  background: #ffffff;\n  border-radius: 10px;\n  height: 70vh;\n  overflow-y: scroll;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.title {\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.subtitle {\n  font-size: 16px;\n  text-align: center;\n  margin-bottom: 20px;\n  color: #555;\n}\n\n.divider {\n  border: none;\n  height: 1px;\n  background: #ddd;\n  margin: 20px 0;\n}\n\n.stepTitle {\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: 20px;\n}\n\n.stepDescription {\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.subStep {\n  font-size: 18px;\n  font-weight: bold;\n  margin-top: 15px;\n  color: #333;\n}\n\n.cnpj {\n  font-size: 18px;\n  font-weight: bold;\n  color: #d9534f;\n}\n\n.category {\n  font-size: 16px;\n  font-weight: bold;\n  color: #0056b3;\n  margin-top: 10px;\n}\n\n.list {\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.list li {\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n\na {\n  color: #007bff;\n  text-decoration: none;\n  font-weight: bold;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.btn_close {\n  border: 2px solid #18316e !important;\n  color: #18316e !important;\n  transition: 500ms all !important;\n  margin-top: 1rem;\n  &:hover {\n    background: #18316e !important;\n    border: 2px solid #18316e !important;\n    color: #fff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__PA4jp`,
	"title": `styles_title__PIxt3`,
	"subtitle": `styles_subtitle__Xzbtg`,
	"divider": `styles_divider__+SDsj`,
	"stepTitle": `styles_stepTitle__O4wTd`,
	"stepDescription": `styles_stepDescription__v7yf1`,
	"subStep": `styles_subStep__O6yfH`,
	"cnpj": `styles_cnpj__2N4+u`,
	"category": `styles_category__KyIWk`,
	"list": `styles_list__BdEnI`,
	"btn_close": `styles_btn_close__RJw1U`
};
export default ___CSS_LOADER_EXPORT___;
